import * as React from 'react';
import * as styles from '../support.module.scss';
import { AppContext } from '../../../shared/app-context';
import ArrowDropDown from '../../../images/icons/arrow-drop-down';
import ArrowDropUp from '../../../images/icons/arrow-drop-up';
import SortingOptions from '../../../models/enums/sortingOptions';
import { SupportContext } from '../../../shared/support-context';

interface Props {
  title: string;
  orderType: string;
  fetchSupportTickets: (arg0: any, arg1: any) => void;
}

const TableColumn = ({ title, orderType, fetchSupportTickets }: Props) => {
  const { state } = React.useContext(AppContext);
  const { orderColumn, orderDirection, searchQuery, selectedFilters, pageSize, currentPage } = React.useContext(
    SupportContext
  );

  return (
    <div className={styles.sortContainer}>
      <span className={orderType === orderColumn ? styles.bold : ''}>{title}</span>{' '}
      <div className={styles.sortIcons}>
        <ArrowDropUp
          height="16"
          width="16"
          color={orderType === orderColumn && orderDirection === SortingOptions.Ascending ? '#00223c' : '#c4c4c4'}
          styles={{ bottom: '-5px' }}
          title="Ascending"
          handleClick={() =>
            fetchSupportTickets(state.clientId, {
              ...selectedFilters,
              searchTerm: searchQuery,
              orderDirection: SortingOptions.Ascending,
              orderColumn: orderType,
              count: pageSize,
              startAt: currentPage
            })
          }
        />
        <ArrowDropDown
          height="16"
          width="16"
          color={orderType === orderColumn && orderDirection === SortingOptions.Descending ? '#00223c' : '#c4c4c4'}
          styles={{ top: '-4px' }}
          title="Descending"
          handleClick={() =>
            fetchSupportTickets(state.clientId, {
              ...selectedFilters,
              searchTerm: searchQuery,
              orderDirection: SortingOptions.Descending,
              orderColumn: orderType,
              count: pageSize,
              startAt: currentPage
            })
          }
        />
      </div>
    </div>
  );
};

export default TableColumn;
